"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeItemFromLocalStorage = exports.setItemInLocalStorage = exports.getItemFromLocalStorage = exports.isDefined = exports.sanitizeUrl = exports.isMobile = exports.getCloudFunctionsOrigin = void 0;
const getCloudFunctionsOrigin = () => {
    if (window.location.hostname === "localhost") {
        const isE2ETest = window.location.pathname.includes("chatbots/typebot-etoe-tests/debug");
        if (isE2ETest) {
            return "https://europe-west3-typebot.cloudfunctions.net";
        }
        return `http://localhost:5001/typebot-dev/europe-west3`;
    }
    return "https://europe-west3-typebot.cloudfunctions.net";
};
exports.getCloudFunctionsOrigin = getCloudFunctionsOrigin;
const isMobile = () => window.matchMedia("(any-hover: none)").matches;
exports.isMobile = isMobile;
const sanitizeUrl = (url) => url.startsWith("http") ||
    url.startsWith("mailto:") ||
    url.startsWith("tel:") ||
    url.startsWith("sms:")
    ? url
    : `https://${url}`;
exports.sanitizeUrl = sanitizeUrl;
const isDefined = (value) => {
    return value !== undefined && value !== null;
};
exports.isDefined = isDefined;
const getItemFromLocalStorage = (item) => {
    try {
        return localStorage.getItem(item);
    }
    catch (err) {
        console.error(err);
        return null;
    }
};
exports.getItemFromLocalStorage = getItemFromLocalStorage;
const setItemInLocalStorage = (item, value) => {
    try {
        localStorage.setItem(item, value);
    }
    catch (err) {
        console.error(err);
    }
};
exports.setItemInLocalStorage = setItemInLocalStorage;
const removeItemFromLocalStorage = (item) => {
    try {
        localStorage.removeItem(item);
    }
    catch (err) {
        console.error(err);
    }
};
exports.removeItemFromLocalStorage = removeItemFromLocalStorage;
//# sourceMappingURL=utils.js.map